let lastScrollY = window.scrollY;
const threshold = 100;

const addScrollListener = () => {
  window.addEventListener('scroll', () => {
    const header = document.querySelector('header');
    if (Math.abs(window.scrollY - lastScrollY) > threshold) {
      if (window.scrollY > lastScrollY) {
        header.classList.add('hidden');
      } else {
        header.classList.remove('hidden');
      }
      lastScrollY = window.scrollY;
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  addScrollListener();
});
